import { createStore } from 'vuex'
import axios from 'axios';

import csvFile from '@/assets/data/compensatie_projecten - dataset_bij_artikel_leveranciers.csv';

export default createStore({
  state: {
    data: {},
    companies: [],
    selectedCompany: undefined,
    selectedIndex: 0,
    selectedProjects: [],
    projects: csvFile
  },
  mutations: {
    SAVE_DATA (state, data) {
      state.data = data;

      state.companies = data.energieleveranciers.map((item, index) => {
        return {label: item.title, index: index}
      });

      state.companies.sort((a,b) => a.label.localeCompare(b.label));

    }, 

    UPDATE_COMPANY(state, obj) {
      state.selectedCompany = state.data.energieleveranciers[obj.index];

      state.selectedProjects = state.projects.filter(item => item['leverancier-id'] === state.selectedCompany.leverancierId)
    }
  },
  getters: {
    title: state => state['data']['title'],
    intro: state => state['data']['intro'],
    companies: state => state['companies'],
    claims: state => state['selectedCompany']['claims'],
    projects_risk_benefit: state => state['selectedCompany']['energieleveranciers_risico_nuts'],
    judgement_projects: state => state['selectedCompany']['judgement_projects'],
    companyName: state => state['selectedCompany']['title'],
    conclusion: state => state['selectedCompany']['conclusion'],
    rebuttal: state => state['selectedCompany']['rebuttal'],
    sources: state => state['data']['sources'],
    selectedCompany: state => state['selectedCompany'],
    selectedCompanyName: state => state['selectedCompany'].title,
    selectedProjects: state => state['selectedProjects'],
  },
  actions: {
    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        axios
          .get(process.env.VUE_APP_API)
          .then(result => {
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },

    updateCompany({commit, state}, company) {
      commit("UPDATE_COMPANY", company);
    }
  },
  modules: {

  }
})
